import { render, staticRenderFns } from "./NetboxStatusChip.vue?vue&type=template&id=f92735b4&scoped=true&"
import script from "./NetboxStatusChip.vue?vue&type=script&lang=ts&"
export * from "./NetboxStatusChip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f92735b4",
  null
  
)

export default component.exports